import { TextInput } from '@ardoq/forms';
import { CustomCellEditorProps } from 'ag-grid-react';
import { useEffect, useRef } from 'react';
import { GroupCellWrapper } from './GroupCellRenderer';
import { FlexBox } from '@ardoq/layout';
import { DEFAULT_GROUP_CELL_LABELS, GroupCellLabels } from '../labels';

type GroupCellEditorParams = {
  showDragHandle?: boolean;
  labels?: Partial<GroupCellLabels>;
};

export type GroupCellEditorProps = CustomCellEditorProps &
  GroupCellEditorParams;

export const GroupCellEditor = (props: GroupCellEditorProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const labels = { ...DEFAULT_GROUP_CELL_LABELS, ...props.labels };

  const canHaveChildNodes = props.node.data?.allowDrop ?? false;
  const hasChildren = (props.node.allChildrenCount ?? 0) > 0;

  const expandedIds: string[] = props.context?.expandedIds ?? [];
  const nodeId = props.node.id!;
  const isExpanded = expandedIds.includes(nodeId);

  const handleChevronClick = () => {
    props.context?.onRowExpansionToggle?.(nodeId, !isExpanded);
  };

  // Replicates autoFocus behavior of AG Grid cell editors
  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  return (
    <FlexBox
      align="center"
      height="full"
      style={{ paddingLeft: AG_GRID_LEFT_PADDING }}
    >
      <GroupCellWrapper
        showDragHandle={!!props.showDragHandle}
        canHaveChildNodes={canHaveChildNodes}
        hasChildren={hasChildren}
        isExpanded={isExpanded}
        node={props.node}
        handleChevronClick={handleChevronClick}
        labels={labels}
      >
        <TextInput
          ref={inputRef}
          value={props.value}
          onChange={e => props.onValueChange(e.target.value)}
          aria-label={labels.inlineTextEditor}
        />
      </GroupCellWrapper>
    </FlexBox>
  );
};

const AG_GRID_LEFT_PADDING = 15; // Default left padding for AG Grid cells
